export function replaceNickname(sentence: string, nickname: string) {
	return sentence.replaceAll('%nickname%', nickname);
}
